import type { SvgIconComponent } from "@mui/icons-material";
import AppsIcon from "@mui/icons-material/Apps";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import StorefrontIcon from "@mui/icons-material/Storefront";
import CategoryIcon from "@mui/icons-material/Category";


export type AnnouncementCategory =
  | "eventos"
  | "alimentacao"
  | "servicos"
  | "produtos"
  | "outros";

export type AnnouncementLinkType = "whatsapp" | "menu" | "site";

export interface IAnnouncement {
  id: string;
  title: string;
  description: string;
  category?: AnnouncementCategory;
  imageUrl?: string | null;
  link?: string;
  linkType?: AnnouncementLinkType;
}

export type CategoryFilter = "todos" | AnnouncementCategory;

export const CATEGORIES: {
  value: CategoryFilter;
  label: string;
  Icon: SvgIconComponent;
}[] = [
  { value: "todos", label: "Todos", Icon: AppsIcon },
  { value: "eventos", label: "Jogos e eventos", Icon: EmojiEventsIcon },
  { value: "alimentacao", label: "Alimentação", Icon: RestaurantIcon },
  { value: "servicos", label: "Serviços", Icon: HomeRepairServiceIcon },
  { value: "produtos", label: "Produtos", Icon: StorefrontIcon },
  { value: "outros", label: "Outros", Icon: CategoryIcon },
];

export const getCategory = (value?: string) =>
  CATEGORIES.find((category) => category.value === value) ??
  CATEGORIES[CATEGORIES.length - 1];

/* Banners enviados pelo admin ficam no Cloudinary, que aceita transformações
   no próprio caminho da URL: o app pede a imagem já reduzida e no melhor
   formato do navegador (WebP/AVIF), nunca o arquivo original. É isso que
   mantém a banda dentro do plano gratuito. */
const IMAGE_TRANSFORMS = {
  card: "c_limit,w_720,q_auto:eco,f_auto",
  detail: "c_limit,w_1000,q_auto,f_auto",
};

const optimizedImageUrl = (url: string, size: keyof typeof IMAGE_TRANSFORMS) =>
  /^https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\//.test(url)
    ? url.replace("/image/upload/", `/image/upload/${IMAGE_TRANSFORMS[size]}/`)
    : url;

// Imagem no tamanho certo para cada lugar e o link do botão de contato
export const resolveAnnouncement = (
  announcement: IAnnouncement,
  size: keyof typeof IMAGE_TRANSFORMS = "card",
) => ({
  imageSrc: announcement.imageUrl
    ? optimizedImageUrl(announcement.imageUrl, size)
    : undefined,
  link: announcement.link || undefined,
  linkType: announcement.linkType ?? "whatsapp",
});
